module.exports = __webpack_public_path__ + "img/telegram.a888fec0.svg";